import { isNotUndefined } from '@standardnotes/utils';
import { Result } from '@standardnotes/domain-core';
export class GetVaultContacts {
    constructor(_findContact, _getVaultUsers) {
        this._findContact = _findContact;
        this._getVaultUsers = _getVaultUsers;
    }
    async execute(dto) {
        const users = await this._getVaultUsers.execute({
            sharedVaultUuid: dto.sharedVaultUuid,
            readFromCache: dto.readFromCache,
        });
        if (users.isFailed()) {
            return Result.fail('Failed to get vault users');
        }
        const contacts = users
            .getValue()
            .map((user) => this._findContact.execute({ userUuid: user.user_uuid }))
            .map((result) => (result.isFailed() ? undefined : result.getValue()))
            .filter(isNotUndefined);
        return Result.ok(contacts);
    }
}
